import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// components
import { Button } from "shared/components/bulma/button";
import { ModalReport } from "shared/components/product";
import { ModalArchive } from "shared/components/product/archiving";

// functions
import { useToggle } from 'shared/functions';
import { DamageReportDropdown } from './damage-report-dropdown';

import { SwapItem } from '../../misc/swap-item';

const DamageRow = ({ report, count }) => {
    const [modal, setModal] = useToggle();
    const [archiveModal, setArchiveModal] = useToggle();
    const [isEdit, setEditable] = useToggle();
    const [user, setUser] = useState(report?.user || {});

    const { barcode } = report;

    if (report.declared_fixed) { report.status = "fixed"; }
    if (report.declared_washing) { report.status = "washing"; }

    const handleReplace = () => {
        setUser({});
    }

    const Modal = () => {
        if (!modal) {
            return null;
        }

        return (
            <ModalReport disabled={true} modal={modal} handleModal={setModal} report={report} />
        );
    }

    const ItemReplacement = () => {
        if (!isEdit) {
            return null;
        }

        return user?.id ? <SwapItem barcode={barcode} onReplace={handleReplace} /> : <p>Item cannot be replaced</p>;
    }

    const handleArchiveModal = () => {
        setArchiveModal();
    }

    if (!report) { return null; }

    return (
        <>
            <tr>
                <th width="5%">{count}</th>
                <td width="10%">
                    <Link to={`/products/${barcode}`} target="_blank">
                        {barcode}
                    </Link>
                </td>
                <td width="20%">
                    <Link to={`/closet-hackers/${user.id}`} target="_blank">
                        {user.full_name}
                    </Link>
                </td>
                <td width="20%">
                    <DamageReportDropdown report={report} disabled={!isEdit} />
                </td>
                <td width="25%">
                    <ItemReplacement />
                </td>
                <td width="5%">
                    <Button name="submit" className="is-primary is-outlined" onClick={setModal}>
                        View
                    </Button>
                </td>
                <td width="5%">
                    <Button name="edit" className={`is-info ${isEdit ? '' : 'is-outlined'}`} onClick={setEditable}>
                        Edit
                    </Button>
                </td>
                <td width="5%">
                    <Button name="archive" className="button is-outlined is-link" onClick={handleArchiveModal}>
                        Archive
                    </Button>
                </td>
            </tr>

            <Modal />
            {/* Archiving Modal */}
            <ModalArchive modal={archiveModal} handleModal={handleArchiveModal} barcode={barcode} ></ModalArchive>
        </>
    );
}

export { DamageRow };
